(function() {
    const $PRIVACY_CONTENT = '.privacy-content',
          $PRIVACY_POPUP = '.privacy-popup',
          $ONETRUST_CONSENT_SDK = '.onetrust-consent-sdk'; 


        if (typeof websiteMode !== "undefined" && websiteMode !== 'e2e-testing') {
            whenAvailable('OnetrustActiveGroups', function() {
                whenAvailable('OneTrust', function() {
                    function updatePrivacyRelatedContent() {
                        if ( !OnetrustActiveGroups.includes('C0004') ) {
                            document.querySelectorAll($PRIVACY_CONTENT).forEach(element => {
                                element.style.display = 'none';
                            });
                        } else {
                            document.querySelectorAll($PRIVACY_CONTENT).forEach(element => {
                                element.style.display = '';
                            });
                        }
                    }

                    updatePrivacyRelatedContent();
                    if (OneTrust && OneTrust?.OnConsentChanged) {
                        OneTrust.OnConsentChanged(() => {
                            updatePrivacyRelatedContent();
                        });
                    }
                    
                    document.querySelectorAll($PRIVACY_POPUP).forEach(element => {
                        element.addEventListener('click', () => {
                            if ( document.querySelector($ONETRUST_CONSENT_SDK) == null ) { 
                                if (OneTrust.LoadBanner) {
                                    OneTrust.LoadBanner();
                                }
                            } 

                            if (OneTrust.ToggleInfoDisplay) {
                                OneTrust.ToggleInfoDisplay();
                            }
                        });
                    });
                });
            });
        }
})();